import { render, staticRenderFns } from "./replenishment.vue?vue&type=template&id=72421be4&scoped=true&"
import script from "./replenishment.vue?vue&type=script&lang=js&"
export * from "./replenishment.vue?vue&type=script&lang=js&"
import style0 from "./replenishment.vue?vue&type=style&index=0&id=72421be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72421be4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72421be4')) {
      api.createRecord('72421be4', component.options)
    } else {
      api.reload('72421be4', component.options)
    }
    module.hot.accept("./replenishment.vue?vue&type=template&id=72421be4&scoped=true&", function () {
      api.rerender('72421be4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/topup/replenishment.vue"
export default component.exports